import { Component, Inject, OnInit } from '@angular/core';
import { AlertService } from '../service/alert.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditAlertComponent } from '../edit-alert/edit-alert.component';


@Component({
  selector: 'app-delete-alert',
  templateUrl: './delete-alert.component.html',
  styleUrls: ['./delete-alert.component.scss']
})
export class DeleteAlertComponent implements OnInit {
  alertID: number;
  airportID: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditAlertComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _alertService: AlertService) {
    this.alertID = data.alertID;
    this.airportID = data.airID;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._alertService.deleteAirportAlert(this.airportID, this.alertID);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
